<template>
  <div>
     <el-row>
      <el-col :span="12"><h3 class="title">联系计划 <svg-icon icon-class="help" /></h3></el-col>
      <el-col :span="12" style="text-align: right">
        <el-button type="text">更多<i class="el-icon-arrow-right el-icon--right"></i></el-button>
      </el-col>
    </el-row>
    <el-table :data="list" style="width: 100%;padding-top: 15px;" :header-cell-style="{'background-color': '#E9F0F7', 'color': '#3C4353'}">
      <el-table-column label="序号" min-width="20">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="标题">
        <template slot-scope="scope">
          {{ scope.row.title | orderNoFilter }}
        </template>
      </el-table-column>
      <el-table-column label="账号" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.username | orderNoFilter }}
        </template>
      </el-table-column>
      <el-table-column label="Status" width="100" align="center">
        <template slot-scope="{row}">
          <el-tag :type="row.status | statusFilter">
            {{ row.status }}
          </el-tag>
        </template>
      </el-table-column>
       <el-table-column label="处理时间">
        <template slot-scope="scope">
          {{ scope.row.finishTime }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { transactionList } from '@/api/remote-search'

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        success: 'success',
        pending: 'danger'
      }
      return statusMap[status]
    },
    orderNoFilter(str) {
      return str.substring(0, 30)
    }
  },
  data() {
    return {
      list: null
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      // transactionList().then(response => {
      //   this.list = response.data.items.slice(0, 8)
      // })
    }
  }
}
</script>
<style scoped>
  .title{
    font-size: 24px;
    color: #3C4353;
    margin: 0px auto 10px auto;
    text-align: left;
    font-weight: bold;
  }
</style>
